<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" >
  <div>
    {{"cancel_order" | translate}}: <strong>{{ data?.orderId }}</strong>
  </div>
</div>

<mat-divider class="-mx-6 text-border"></mat-divider>

<mat-dialog-content >
  <div class="flex flex-col" [formGroup]="form">
    <mat-form-field appearance="outline" class="mt-1 flex-auto">
      <mat-label>{{"reason" | translate}}</mat-label>
      <mat-select formControlName="reason" required #reasonSelect (selectionChange)="onChange($event)">
        <mat-option *ngFor="let reason of reasons" [value]="translateHelper.localize(reason)" >{{translateHelper.localize(reason)}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mt-1 flex-auto" *ngIf="form.get('other').enabled">
      <mat-label>{{"other_reason" | translate}}</mat-label>
      <input type="text" formControlName="other" matInput required/>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mt-1 flex-auto">
      <mat-label>{{"note" | translate}}</mat-label>
      <textarea formControlName="note" matInput ></textarea>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button button color="primary" mat-raised-button type="button" (click)="submit()">{{"Submit" | translate}}</button>
</mat-dialog-actions>
